import { ErrorBoundary } from "react-error-boundary";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FallBackError from "./components/FallBackError";
import Offline from "./components/Offline";
import StartUpScreen from "./containers/StartUpScreen";
import ContextProvider from "./context";
import store from "./redux/store";

function App() {
  const handleBoundaryError = (error, errorInfo) => {
    console.log("Error Occurred ", error, errorInfo);
  };
  return (
    <ContextProvider>
      <Provider store={store}>
        <Router>
          <ToastContainer
            position="bottom-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
          <Offline />
          <ErrorBoundary
            FallbackComponent={FallBackError}
            onError={handleBoundaryError}
          >
            <StartUpScreen />
          </ErrorBoundary>
        </Router>
      </Provider>
    </ContextProvider>
  );
}

export default App;
